<template>
  <div class="flex flex-col gap-20">
    <div class="flex items-center justify-center flex-1">
      <BittsEmptyState
        title="By Partners view coming soon"
        description="You'll be able to view and manage sharing settings for all your partners from here."
        :font-awesome-icon="['fak', 'partner']"
        :font-awesome-icon-style="{ height: '52px', width: '52px' }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsEmptyState } from '@crossbeam/bitts';

import { computed, ref } from 'vue';

const hasAnyChanges = ref(false);
const isSaving = ref(false);

defineExpose({
  hasAnyChanges,
  isSaving,
  hasPopulations: computed(() => false),
  async saveChanges() {
    // No-op placeholder
  },
});
</script>
